/**
 * Unauthorized Page
 * Displayed when user doesn't have required permissions
 */

import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ShieldAlert } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: ${({ theme }) => theme.spacing[4]};
  background: ${({ theme }) => theme.colors.backgrounds.page};
`;

const Content = styled(Card)`
  max-width: 500px;
  text-align: center;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin: 0 auto ${({ theme }) => theme.spacing[6]};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  background: ${({ theme }) => theme.colors.status.error.bg};
  color: ${({ theme }) => theme.colors.status.error.text};

  svg {
    width: 40px;
    height: 40px;
  }
`;

const Title = styled.h1`
  font-size: ${({ theme }) => theme.typography.fontSize['3xl']};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: ${({ theme }) => theme.spacing[3]};
`;

const Description = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.base};
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: ${({ theme }) => theme.typography.lineHeight.relaxed};
  margin-bottom: ${({ theme }) => theme.spacing[6]};
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[3]};
  justify-content: center;
`;

export const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Content>
        <IconWrapper>
          <ShieldAlert />
        </IconWrapper>
        <Title>Access Denied</Title>
        <Description>
          You don't have permission to access this page. Please contact your administrator if you
          believe you should have access.
        </Description>
        <ButtonGroup>
          <Button variant="secondary" onClick={() => navigate(-1)}>
            Go Back
          </Button>
          <Button variant="primary" onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </Button>
        </ButtonGroup>
      </Content>
    </Container>
  );
};

export default UnauthorizedPage;
